import { Box, Typography } from "@material-ui/core";
import { Trans } from "@lingui/macro";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import theme from "../../theme";
import Image from "material-ui-image";

const useStyles = makeStyles((theme) => ({
  infoContainer: {
    width: "100%",
    height: "300px",
    overflow: "auto",
    marginTop: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      height: "100%",
    },
  },
  mobileFooter: {
    [theme.breakpoints.down("sm")]: {
      height: "100px",
    },
  },
}));

const FullInfo = () => {
  const classes = useStyles(theme);

  return (
    <Box>
      <Box mt={1}>
        <Image
          disableSpinner
          color={theme.palette.darkGray}
          src={"/images/crenex-logo-light.jpg"}
          style={{
            height: "42px",
            padding: "0",
            width: "97px",
            backgroundColor: "white",
          }}
          imageStyle={{
            height: "100%",
            width: "100%",
            objectFit: "cover",
          }}
        />
      </Box>
      <Box className={classes.infoContainer}>
        <Typography variant="h1" style={{ fontSize: "28px" }}>
          <Trans>Resumen de privacidad</Trans>
        </Typography>
        <Box mt={2}>
          <Typography variant="body1">
            <Trans>
              Esta web utiliza cookies para que podamos ofrecerte la mejor experiencia de usuario posible. La
              información de las cookies se almacena en tu navegador y realiza funciones tales como reconocerte cuando
              vuelves a nuestra web o ayudar a nuestro equipo a comprender qué secciones de la web encuentras más
              interesantes y útiles.
            </Trans>
          </Typography>
        </Box>
        <Box mt={2}>
          <Typography variant="h1" style={{ fontSize: "28px" }}>
            <Trans>Cookies estictamente necesarias</Trans>
          </Typography>
          <Box mt={2}>
            <Typography variant="body1">
              <Trans>
                Las cookies estrictamente necesarias tiene que activarse siempre para que podamos guardar tus
                preferencias de ajustes de cookies. Si desactivas esta cookie no podremos guardar tus preferencias. Esto
                significa que cada vez que visites esta web tendrás que activar o desactivar las cookies de nuevo.
              </Trans>
            </Typography>
          </Box>
        </Box>
        <Box mt={2}>
          <Typography variant="h1" style={{ fontSize: "28px" }}>
            <Trans>Política de cookies</Trans>
          </Typography>
          <Box mt={2}>
            <Typography variant="body1">
              <Trans>
                Es una pena, pero sí, nuestra página también es una de las cientos de millones de webs que se benefician
                de las cookies para analizar la navegación que hace el usuario.
              </Trans>
            </Typography>
          </Box>
          <Box mt={2}>
            <Typography variant="body1">
              <Trans>
                Sabemos lo feo e incómodo que resulta el anuncio que sale para clicar y cerrar anunciando las cookies,
                no es de nuestro agrado. Pero es una necesidad por ley, así que no queda otra.
              </Trans>
            </Typography>
          </Box>
          <Box mt={2}>
            <Typography variant="body1">
              <Trans>
                Ya lo habrás leído (bueno, seguramente no lo habrás leído nunca 🤣) en otros sitios web, que recogemos
                información del usuario…nada, no es para tanto. Ni el 0,00001% de lo que subes a las redes sociales!
              </Trans>
            </Typography>
          </Box>
          <Box mt={2}>
            <Typography variant="body1">
              <Trans>
                No te creas que por entrar en nuestra web, vamos a tener acceso a tus fotos del verano en Formentera y
                de la boda de tu primo Antonio, o a tu historial de navegación 😎. Nada de eso es accesible, y además
                ¡preferimos ni saberlo! Únicamente se queda la manera en la que te has movido en la web: la navegación -
                tiempos, lugares de clic, sesiones, paginas por sesión…-. A fin de cuentas, un motón de datos brutos que
                nos muestra el comportamiento del usuario, con el fin de que nosotros podamos adaptar nuestro producto a
                vuestras necesidades. En resumen, mejorar vuestra experiencia mejorando nuestro producto.
              </Trans>
            </Typography>
          </Box>
          <Box mt={2}>
            <Typography variant="body1">
              <Trans>
                Una cookie 🍪, es un pequeño archivo que se queda almacenado en tu navegador (y no en tu disco duro).
              </Trans>
            </Typography>
          </Box>
          <Box mt={2}>
            <Typography variant="body1">
              <Trans>En Book A Corner, utilizamos estos tipos de cookies:</Trans>
            </Typography>
          </Box>
          <Box mt={2}>
            <uL>
              <li>
                <Typography variant="body1">
                  <strong>
                    <Trans>Cookies propias</Trans>
                  </strong>
                  <Trans>: (cookies de sesión) controlan el spam y los bots que puedan afectar a nuestra web</Trans>
                </Typography>
              </li>
              <li>
                <Box mt={2}>
                  <Typography variant="body1">
                    <strong>
                      <Trans>Cookies de terceros</Trans>
                    </strong>
                    <Trans>
                      : las de Google Analytics, que son las que nos facilitan cantidad de información sobre lo que pasa
                      en nuestra web; y las cookies de RRSS, que son las que usan para analizar compartes o das like.
                    </Trans>
                  </Typography>
                </Box>
              </li>
            </uL>
            <Box mt={2}>
              <Typography variant="body1">
                <Trans>
                  Obviamente, toda esta información que se guarda, se puede borrar en cualquier momento. Eso dependerá
                  del navegador que uses: Chore, Firefox, Safari, Edge, Opera… (dime que no usas Explorer ya! 🙏).
                </Trans>
              </Typography>
            </Box>
            <Box mt={2}>
              <Typography variant="body1">
                <Trans>
                  Aquí os dejamos, por si os interesa, un poquito más de información específica y aburrida acerca de las
                  cookies.
                </Trans>
              </Typography>
            </Box>
            <Box mt={2}>
              <Typography variant="body1">
                <Trans>¡¡¡Muchas gracias por vuestra atención!!!</Trans>
              </Typography>
            </Box>
            <Box mt={2}>
              <Typography variant="subtitle1">
                <Trans>Datos del responsable</Trans>
              </Typography>
              <Box mt={1}>
                <Typography variant="body1">
                  <Trans>
                    En cumplimiento de lo dispuesto en el Reglamento General de Protección de Datos 679/2016, la Ley
                    Orgánica 15/1999, de Protección de Datos de Carácter Personal (en adelante “LOPD”), y Ley 34/2002 de
                    11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico, y restante
                    normativa de aplicación, te informamos que el Responsable de los datos personales tratados en el
                    Sitio Web www.bookacorner.net, es propiedad de BOOK A CORNER, S.L. (En adelante La Empresa), con
                    domicilio social en Calle Gobernador, 23, 280314, MADRID, MADRID, C.I.F nº B88533435, Teléfono
                    637747917 y correo electrónico info@bookacorner.com
                  </Trans>
                </Typography>
              </Box>
              <Box mt={2}>
                <Typography variant="body1">
                  <Trans>
                    Le informamos que este Sitio Web utiliza una tecnología denominada “Cookies” con el fin de facilitar
                    la navegación de los Usuarios, mostrarles información de su interés siempre que acceda a nuestro
                    Sitio Web y mejorar la calidad de nuestros servicios. El Usuario podrá encontrar en nuestra Política
                    de Cookies información sobre el tipo de Cookies que utilizamos, los fines para los que se utilizan y
                    las opciones de las que dispone para controlarlas o eliminarlas. En caso de que el Usuario requiera
                    información adicional sobre las Cookies que utilizamos en el Sitio Web, podrá remitir un correo
                    electrónico al correo electrónico que le hemos indicado en el párrafo precedente.
                  </Trans>
                </Typography>
              </Box>
              <Box mt={2}>
                <Typography variant="subtitle1">
                  <Trans>¿Qué son las cookies?</Trans>
                </Typography>
                <Box mt={1}>
                  <Trans>
                    Una Cookie es un archivo que se descarga en tu equipo (ordenador o dispositivo móvil) con el fin de
                    almacenar datos que podrán ser actualizados y recuperados por la Empresa.La información recabada a
                    través de las Cookies puede incluir la fecha y hora de visitas al Sitio Web, las páginas visitadas,
                    el tiempo que has estado en nuestro Sitio Web y las acciones realizadas, así como los sitios
                    visitados justo antes y después de la visita. Mediante el uso de estos dispositivos se permite al
                    servidor Web recordar algunos datos concernientes al usuario, como sus preferencias para la
                    visualización de las páginas de ese servidor, nombre y contraseña, productos que más le interesan,
                    etc.
                  </Trans>
                </Box>
              </Box>
              <Box mt={2}>
                <Typography variant="subtitle1">
                  <Trans>Cookies afectadas por la normativa y cookies exceptuadas</Trans>
                </Typography>
                <Box mt={1}>
                  <Trans>
                    Las cookies que requieren el consentimiento informado por parte del usuario son las cookies de
                    analítica y las de publicidad y afiliación, quedando exceptuadas las de carácter técnico y las
                    necesarias para el funcionamiento del sitio web o la prestación de servicios expresamente
                    solicitados por el usuario.
                  </Trans>
                </Box>
              </Box>
              <Box mt={2}>
                <Typography variant="subtitle1">
                  <Trans>¿Qué tipo de cookies podrían usarse en este sitio web y con que finalidad?</Trans>
                </Typography>
                <Box mt={1}>
                  <Typography variant="body1">
                    <Trans>Nuestro Sitio Web podría utilizar las Cookies que se describen a continuación:</Trans>
                  </Typography>
                </Box>
                <Box mt={2}>
                  <Typography variant="body1">
                    <strong>
                      <Trans>Cookies de sesión</Trans>
                    </strong>
                    <Trans>
                      : son un tipo de Cookies diseñadas para recabar y almacenar datos mientras el Usuario accede a una
                      página web.Cookies persistentes: son un tipo de Cookies en el que los datos siguen almacenados en
                      el terminal y pueden ser accedidos y tratados durante un periodo definido por el responsable de la
                      Cookie, y que puede ir de unos minutos a varios años.
                    </Trans>
                  </Typography>
                </Box>
                <Box mt={2}>
                  <Typography variant="body1">
                    <strong>
                      <Trans>Cookies técnicas</Trans>
                    </strong>
                    <Trans>
                      : son aquéllas que permiten la navegación a través de una página web, plataforma o aplicación y la
                      utilización de las diferentes opciones o servicios que en ella existan como, por ejemplo,
                      controlar el tráfico y la comunicación de datos, identificar la sesión, acceder a partes de acceso
                      restringido, recordar los elementos que integran un pedido, realizar el proceso de compra de un
                      pedido, realizar la solicitud de inscripción o participación en un evento, utilizar elementos de
                      seguridad durante la navegación, almacenar contenidos para la difusión de vídeos o sonido o
                      compartir contenidos a través de redes sociales.
                    </Trans>
                  </Typography>
                </Box>
                <Box mt={2}>
                  <Typography variant="body1">
                    <strong>
                      <Trans>Cookies de personalización</Trans>
                    </strong>
                    <Trans>
                      : son aquéllas que permiten al Usuario acceder al servicio con algunas características
                      predefinidas en función de una serie de criterios en el terminal del Usuario como por ejemplo el
                      idioma, el tipo de navegador a través del cual accede al servicio, la configuración regional desde
                      donde accede al servicio, etc.
                    </Trans>
                  </Typography>
                </Box>
                <Box mt={2}>
                  <Typography variant="body1">
                    <strong>
                      <Trans>Cookies de análisis</Trans>
                    </strong>
                    <Trans>
                      : son aquéllas que permiten al responsable de las mismas, el seguimiento y análisis del
                      comportamiento de los Usuarios de los sitios web a los que están vinculadas. La información
                      recogida mediante este tipo de Cookies se utiliza en la medición de la actividad de los sitios
                      web, aplicación o plataforma y para la elaboración de perfiles de navegación de los usuarios de
                      dichos sitios, aplicaciones y plataformas, con el fin de introducir mejoras en función del
                      análisis de los datos de uso que hacen los usuarios del servicio.
                    </Trans>
                  </Typography>
                </Box>
                <Box mt={2}>
                  <Typography variant="body1">
                    <strong>
                      <Trans>Cookies publicitarias</Trans>
                    </strong>
                    <Trans>
                      : permiten la gestión de la forma más eficaz posible, de los espacios publicitarios que, en su
                      caso, el editor haya incluido en una página web, aplicación o plataforma desde la que presta el
                      servicio solicitado, en base a criterios como el contenido, o la frecuencia en la que se muestran
                      los anuncios.
                    </Trans>
                  </Typography>
                </Box>
                <Box mt={2}>
                  <Typography variant="body1">
                    <strong>
                      <Trans>Cookies propias</Trans>
                    </strong>
                    <Trans>
                      : estas Cookies son enviadas al ordenador del Usuario y gestionadas exclusivamente por el titular
                      del Sitio Web para el mejor funcionamiento del Sitio Web. La información que recabamos se emplea
                      para mejorar la calidad de nuestro servicio y su experiencia como usuario. Estas Cookies
                      permanecen en su navegador más tiempo, permitiéndonos reconocerle como visitante recurrente del
                      Sitio Web y adaptar el contenido para ofrecerle contenidos que se ajusten a sus preferencias.
                    </Trans>
                  </Typography>
                </Box>
                <Box mt={2}>
                  <Typography variant="body1">
                    <strong>
                      <Trans>Cookies analíticas de terceros</Trans>
                    </strong>
                    <Trans>
                      : en nuestro Sitio Web también podríamos utilizar el sistema de medición de audiencia Google
                      Analytics, una herramienta de análisis web de Google que nos permite conocer cómo interactúan los
                      usuarios de nuestro Sitio Web. Asimismo, habilita Cookies en el dominio del sitio en el que se
                      encuentra el usuario y utiliza un conjunto de Cookies para recopilar información de forma anónima
                      y elaborar informes de tendencias del Sitio Web sin identificar a usuarios individuales.
                    </Trans>
                  </Typography>
                </Box>
                <Box mt={2}>
                  <Typography variant="body1">
                    <strong>
                      <u>
                        <Trans>Más información</Trans>
                      </u>
                    </strong>{" "}
                    <Trans>sobre el tipo de Cookies que utiliza Google Analitycs y su periodo de expiración.</Trans>
                  </Typography>
                </Box>
              </Box>
              <Box mt={2}>
                <Typography variant="subtitle1">
                  <Trans>¿Cuándo otorgo mi consentimiento para el uso de cookies?</Trans>
                </Typography>
                <Box mt={1}>
                  <Trans>
                    Cuando el Usuario accede a nuestro Sitio Web y antes de comenzar la navegación, es advertido sobre
                    el uso de Cookies de manera que puede prestar su consentimiento con relación a nuestra Política de
                    Cookies “Aceptando” o “Rechazando” en la ventana informativa. También podrás configurarlas.Sin
                    embargo, ten en cuenta que, en la mayoría de los casos, eliminar o deshabilitar las Cookies podría
                    afectar la funcionalidad de nuestro Sitio Web y limitarte el acceso a ciertas áreas o servicios
                    ofrecidos a través del mismo.
                  </Trans>
                </Box>
              </Box>
              <Box mt={2}>
                <Typography variant="subtitle1">
                  <Trans>¿Cómo puedo deshabilitar y bloquear las cookies?</Trans>
                </Typography>
                <Box mt={1}>
                  <Trans>
                    Podrás en cualquier momento deshabilitar las Cookies y continuar tu navegación. Podrás bloquearlas o
                    deshabilitarlas activando la configuración de tu navegador, que te permite rechazar la instalación
                    de todas las Cookies o de algunas de ellas. Algunos de los navegadores permiten advertir de la
                    presencia de Cookies o rechazarlas automáticamente. Si las rechazas podrá seguir usando nuestro
                    Sitio Web, aunque el uso de algunos de sus servicios podrá ser limitado y por tanto tu experiencia
                    en nuestro Sitio Web menos satisfactoria.Para optar por no ser rastreados por Google Analytics en
                    todas las páginas web, visita el siguiente enlace: Página de descarga del complemento de
                    inhabilitación para navegadores de Google Analytics . Para obtener más información sobre la forma de
                    ajustar la configuración de las Cookies, según el navegador que utilices habitualmente, te
                    recomendamos que visites los siguientes enlaces:
                  </Trans>
                </Box>
              </Box>
              <Box mt={2}>
                <ul>
                  <li>
                    <Typography variant="body1">
                      <strong>
                        <u>Internet Explorer</u>
                      </strong>
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body1">
                      <strong>
                        <u>Firefox</u>
                      </strong>
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body1">
                      <strong>
                        <u>Chrome</u>
                      </strong>
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body1">
                      <strong>
                        <u>Safari</u>
                      </strong>
                    </Typography>
                  </li>
                </ul>
              </Box>
              <Box mt={2}>
                <Typography variant="subtitle1">
                  <Trans>¿Cómo puedo revocar mi consentimiento?</Trans>
                </Typography>
                <Box mt={1}>
                  <Trans>
                    Podrás, en cualquier momento, revocar el consentimiento otorgado en relación al uso de Cookies que
                    nos autorices a realizar, para lo cual deberás eliminar las Cookies almacenadas en tu equipo
                    (ordenador o dispositivo móvil) a través de los ajustes y configuraciones de tu navegador de
                    Internet.Sin embargo, ten en cuenta que en la mayoría de los casos, eliminar o deshabilitar las
                    Cookies podría afectar la funcionalidad de nuestro Sitio Web y limitarle el acceso a ciertas áreas o
                    servicios ofrecidos a través del mismo.
                  </Trans>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box className={classes.mobileFooter}></Box>
    </Box>
  );
};

export default FullInfo;
